import { processKilometers, processPriceString } from '@/general/helpers/processProductApiData';
import { BaseCarData } from '@/types/Car.types';
import { ProductListDataRow } from '@/types/CataloguePage.types';
import { ProductDetailsPayload, ProductDetailsPayloadFields } from '@/types/ProductDetail.type';
import { getOr } from '@/utils/getOr';

export const productDetailPayloadToBaseCarData = (
  productDetail: ProductDetailsPayload | ProductListDataRow,
): BaseCarData => {
  return {
    sku: productDetail.sku,
    state: 'state' in productDetail ? productDetail.state : productDetail.status,
    variant: productDetail.variant,
    model: [productDetail.buildYear, productDetail.make, productDetail.model].join(' '),
    makeModel: [productDetail.make, productDetail.model],
    imageUrl: 'card' in productDetail ? productDetail.card : getOr(productDetail, 'images.card.url', ''),
    kilometers: processKilometers(productDetail.kilometres),
    fuelType: productDetail.fuelType,
    transmission: productDetail.transmission,
    bodyType: productDetail.body,
    colour: productDetail.colour,
    ancapRating: productDetail.ancapRating,
    price: processPriceString(productDetail.price),
    dutyPrice: processPriceString(productDetail.dutyPrice),
    buildYear: productDetail.buildYear,
    promotionTags: productDetail.search_keywords,
    weeklyRepayment: productDetail.weeklyRepayment,
    watchers: productDetail.watchers,
    [ProductDetailsPayloadFields.remainingWarrantyMonths]:
      productDetail[ProductDetailsPayloadFields.remainingWarrantyMonths],
  };
};
